import { ICustomerTemplate } from "@/interfaces/customer-template.interface";
import { MessageTemplateMessages } from "@/messages/message-template/message-template.messages";
import { FilterType, IFilter } from "@/types/filter.types";

export const MESSAGE_TEMPLATE_TABLE_COLUMNS = (messages: MessageTemplateMessages) => [
  messages.idColumn,
  messages.platformColumn,
  messages.typeColumn,
  messages.statusColumn,
  messages.notificationOnColumn,
  messages.rowDateColumn,
  messages.optionsColumn,
];

export const initialFilterValues: IFilter<ICustomerTemplate>[] = [
  {
    property: "name",
    value: "",
    filterType: FilterType.Contains,
  },
];
